import React, { Component } from "react"
import withStyles from "@material-ui/styles/withStyles"

import ThreeAsTwo from "../../../components/Steps/ThreeAsTwo"
import base, { storage } from '../../../config/rebase'
import Wrapper from "../../../components/Common/Wrapper"
import { checkBannerFileExt, isBannerSubsAvailable, toLocaleDS_BL } from "../../../utils"
import BannerInput from "../../../components/Paper/BannerInput"
import CustomCardItemIcon from "../../../components/Cards/CustomCardItemIcon"
import { FormHelperText, Typography } from "@material-ui/core"
import CustomBtn from "../../../components/Buttons/CustomBtn"
import { Attachment, Warning } from "@material-ui/icons"
import { Link } from "react-router-dom"
import ConfirmDialog from "../../../components/Dialogs/ConfirmDialog"
import CustomAlert from "../../../components/CustomAlert"
import { dbPrefix } from "../../../Constants"
import InformationDialog from "../../../components/Dialogs/InformationDialog"
import Status from "../../../components/Paper/Status"
import Reports from "../../../components/Paper/Reports"
import rebase from "../../../config/rebase"
import CustomCardItem from "../../../components/Cards/CustomCardItem"
import { getReportsForPaper } from "../../../rebaseService"

const styles = theme => ({
  paper: {
    margin: '10px',
    padding: theme.spacing(3),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  root: {
    flexGrow: 1,
    marginTop: '72px',
  },
  grid: {
    width: 1200,
    marginTop: 40,
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 20px)"
    }
  },
  rangeLabel: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2)
  },
  topBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 32
  },
  outlinedButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1)
  },
  actionButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1),
    width: 152
  },
  blockCenter: {
    padding: theme.spacing(2),
    lign: "center"
  },
  block: {
    padding: theme.spacing(2)
  },
  box: {
    marginBottom: 40,
    height: 65
  },
  inlining: {
    display: "inline-block",
    marginRight: 10
  },
  buttonBar: {
    display: "flex"
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end"
  },
  noBorder: {
    borderBottomStyle: "hidden"
  },
  loadingState: {
    opacity: 0.05
  },
  loadingMessage: {
    position: "absolute",
    top: "40%",
    left: "40%"
  }
})

class Papers extends Component {

  state = {
    users: [],
    showSaveBannerDialog: false,
    message: false,
    paper: false,
    error: false,
    loaded: false,
    bannerURL: null
  }

  async componentDidMount() {
    const { id } = this.props.match.params
    const { user } = this.props

    if (!id) {
      return window.location.replace('/')
    }

    try {
      const paper = await base.fetch(dbPrefix + 'papers/' + id, {
        asArray: false
      })

      if (paper) {
        const isUserFirstAuthor = paper.firstAuthor === user.key

        for (let index = 0; index < paper.usersId.length; index++) {
          const cpf = paper.usersId[index]
          const user = await base.fetch(dbPrefix + 'users/' + cpf, {
            asArray: false
          })
          const reports = await getReportsForPaper(paper.knowledgeArea, paper.key)
          paper.reports = reports
          this.setState({ users: [...this.state.users, user], firstAuthor: paper.firstAuthor, isUserFirstAuthor })
        }
      } else {
        this.setState({ fatalError: "Trabalho não encontrado" })
      }
      this.setState({ paper })

    } catch (error) {
      this.setState({ fatalError: "Ocorreu um erro..." })
    } finally {
      this.setState({ loaded: true })
    }
  }

  handleFileChange = e => {
    if (!checkBannerFileExt(e.target.files[0].name)) {
      return this.setState({ bannerURL: false, error: "Extensão de arquivo Inválida. Você precisa inserir uma extensão de arquivo válida" })
    }
    return this.setState({ bannerURL: e.target.files[0] })
  }

  handleSaveBanner = async () => {
    this.setState({ loaded: false })
    const { bannerURL } = this.state

    if (!bannerURL) {
      return this.setState({ showSaveBannerDialog: false, error: "Arquivo não inserido. Por favor insira o modelo fornecido na extensão válida ", loaded: true })
    }
    if (!checkBannerFileExt(bannerURL.name)) {
      return this.setState({ bannerURL: false, error: "Extensão de arquivo Inválida. Você precisa inserir uma extensão de arquivo válida", loaded: true })
    }

    const name = new Date().getTime() + bannerURL.name.split('.')[1]
    const ref = storage.ref('banners/' + name)

    ref.put(bannerURL)
      .then(img => {
        img.ref.getDownloadURL()
          // Inicia imagem para pegar url gerada
          .then(dURL => {
            this.setState({ paper: { ...this.state.paper, bannerURL: dURL } })
            rebase.update(dbPrefix + 'papers/' + this.props.match.params.id, {
              data: {
                bannerURL: dURL
              }
            }).then(() => {
              this.setState({ success: "Banner enviado com sucesso!", paper: { ...this.state.paper, bannerURL: dURL } })
            }).catch(error => {
              console.log(error)
              this.setState({ error })
            }).finally(() => {
              this.setState({ loaded: true, showSaveBannerDialog: false })
            })
          }).catch(error => {
            console.log(error)
            this.setState({ error })
          }).finally(() => {
            this.setState({ loaded: true, showSaveBannerDialog: false })
          })
      })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }
  render() {
    const { classes } = this.props
    const { paper, users, bannerURL, isUserFirstAuthor } = this.state

    return (
      <Wrapper loaded={this.state.loaded} success={this.state.success} fatalError={this.state.fatalError} error={this.state.error} currentPath={"/meus-trabalhos"} subscribedTopbar>
        <Status accepted={paper.accepted} finalGrade={paper.finalGrade} />
        <br />
        {paper.accepted && !paper.banner && <CustomAlert severity="info" message="Parabéns! Seu trabalho foi selecionado para apresentação oral!" />}

        {
          paper.banner && paper.accepted && paper.bannerURL && <>
            <CustomCardItem>
              <Typography variant="h3">Banner depositado</Typography>
              <img className="bannerImg" src={paper.bannerURL} alt="Banner depositado" />
            </CustomCardItem>
          </>
        }
        {
          isUserFirstAuthor && !paper.bannerURL && paper.banner && paper.accepted && isBannerSubsAvailable() && (
            <>
              <CustomCardItemIcon icon={<Warning />}>
                <Typography variant="h5">ATENÇÃO</Typography>
                Apenas o primeiro autor, pode:
                <ul>
                  <li><b>Depositar o <i>banner</i></b></li>
                </ul>
                Ao enviar seu banner, certifique-se de que é uma imagem no formato de imagem descrito nas normas.
                <Typography variant="h5">Dúvidas? <Link to="/mais" >Confira as normas aqui </Link></Typography>
              </CustomCardItemIcon>

              <CustomCardItemIcon icon={<Attachment />}>
                <Typography variant="h5">Depósito de Banner</Typography>
                <BannerInput handleFileChange={this.handleFileChange} bannerFile={bannerURL} />
                <FormHelperText>
                  <CustomAlert message="Trabalhos sem banner TAMBÉM NÃO serão apresentados" />
                  <Typography variant="h6">
                    Você deve enviar o <i>banner</i> até dia {toLocaleDS_BL()}.
                  </Typography>
                </FormHelperText>
                <CustomBtn fullWidth title="Enviar Banner" onClick={() => this.setState({ showSaveBannerDialog: true })} />
              </CustomCardItemIcon>
            </>
          )
        }
        <ThreeAsTwo
          readOnly={true}
          knowledgeArea={paper.knowledgeArea}
          firstAuthor={paper.firstAuthor}
          paperTitle={paper.paperTitle}
          paperFile={paper.paperFile}
          videoLink={paper.videoLink}
          paperURL={paper.paperURL}
          abstract={paper.abstract}
          userType={"2"}
          classes={classes}
          users={users}
        />
        {paper.reports && <Reports reports={Object.values(paper.reports)} />}

        <InformationDialog
          title="Erro"
          message={this.state.error}
          open={this.state.error}
          handleClose={() => this.setState({ error: false })}
        />
        <ConfirmDialog
          title="Enviar Banner?"
          message="ATENÇÃO: Esta ação é crítica e irreversível."
          open={this.state.showSaveBannerDialog}
          agree={() => this.handleSaveBanner()}
          handleClose={() => this.setState({ showSaveBannerDialog: false })}
        />
      </Wrapper >
    )
  }
}
export default withStyles(styles)(Papers)
